import axios from "axios";
import { log } from "@/plugins/consoleLogger";
import { sessionsUrl } from "../moduleUrls";

const getSession = async (uid) => {
  try {
    const res = await axios.post(
      sessionsUrl + "/session",
      {
        cdr_token_uid: uid
      },
      {
        timeout: 30000
      }
    );

    log("log", res);

    if (res.status === 200) {
      return res;
    } else {
      throw new Error("Unable to acess Sessions API");
    }
  } catch (err) {
    log("error", `Failed Backoffice call with: ${err.toString()}`);
    throw new Error("Unable to acess Sessions API");
  }
};

export { getSession };
